import React from 'react';
import { StatusMessage } from 'is24-corecss';
import { css } from '@emotion/css';
import { Benefit } from '../../../../@types/benefits';
import { useAcknowledgeNotification } from '../../../../apiHooks/notifications.hook';

const styles = {
  container: css`
    margin-bottom: 16px;

    @media screen and (min-width: 576px) {
      width: 530px;
    }
  `,
};

interface Props {
  id?: string;
  benefit: Benefit;
  statusType: 'confirm' | 'info' | 'error';
  headline: React.ReactElement | string;
  content: React.ReactElement;
}

export const GenericNotification = ({ id, benefit, statusType, content, headline }: Props) => {
  const { acknowledgeNotification } = useAcknowledgeNotification();

  return (
    <div className={styles.container}>
      <StatusMessage
        statusType={statusType}
        headline={headline}
        message={content}
        onClose={id ? () => acknowledgeNotification({ benefitId: benefit, notificationId: id }) : undefined}
      />
    </div>
  );
};
